import { useCallback, useState } from "react";
import { SelectWrapper } from "./SelectWrapper";
import * as Icons from 'react-icons/bs';
import { Form } from "react-bootstrap";
import { OptionType } from "../../types";

export type SelectAndTextPanelProps = {
    title: string,
    options: OptionType[],
    selectValue: OptionType,
    textValues: string[],
    onChange: (selectValue: OptionType, textValues: string[]) => void,
}

export const SelectAndTextPanel = ({
    title,
    options,
    selectValue,
    textValues,
    onChange
}: SelectAndTextPanelProps) => {
    const [focusedValue, setFocusedValue] = useState<string | undefined>();
    const [textBoxValue, setTextBoxValue] = useState<string>();

    const handleAddOption = useCallback(() => {
        if (!textBoxValue) return;
        if (textValues.find(v => v === textBoxValue)) return;
        onChange(selectValue, [...textValues, textBoxValue]);
        setTextBoxValue('');

    }, [textBoxValue, textValues, onChange, selectValue]);

    const handleRemoveOption = useCallback(() => {
        if (!focusedValue) return;

        onChange(selectValue, textValues.filter(v => v !== focusedValue));
        setFocusedValue(undefined);
    }, [focusedValue, onChange, selectValue, textValues]);

    return (
        <div className='advanced-search-panel select'>
            <div className='advanced-search-panel-title'>
                {title}
            </div>
            <div className='advanced-search-panel-content'>
                <div className='advanced-search-panel-content-header'>
                    <SelectWrapper
                        value={selectValue}
                        onChange={(newValue) => { if (newValue) onChange(newValue, textValues) }}
                        options={options}
                    />
                    <Form.Control
                        className="form-control"
                        type="string"
                        value={textBoxValue}
                        onChange={(e) => setTextBoxValue(e.target.value)}
                    />
                </div>
                <div className='advanced-search-panel-options'>
                    <div className='advanced-search-panel-options-inner'>
                        {
                            textValues.map(v =>
                                <div
                                    key={v}
                                    className={`advanced-search-panel-label ${focusedValue === v ? 'active' : ''}`}
                                    onClick={() => setFocusedValue(v)}
                                >
                                    {v}
                                </div>
                            )
                        }
                    </div>
                    <div className='advanced-search-panel-options-actions'>
                        <div className='advanced-search-panel-options-action'>
                            <Icons.BsPlus
                                className={textValues.find(v => v === textBoxValue) ? 'disabled action-button' : 'action-button'}
                                onClick={handleAddOption}
                            />
                        </div>
                        <div className='advanced-search-panel-options-action'>
                            <Icons.BsDash
                                className={!focusedValue ? 'disabled action-button' : 'action-button'}
                                onClick={handleRemoveOption}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}